import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHouseMeterTariffs = async () => {
  return await request.get(
    `/Meter/house_meter_tariffs`,
    {},
    'При загрузке тарифов ОДПУ произошла ошибка'
  );
};

export const useHouseMeterTariffsQuery = (options) =>
  useQuery(getQueryKeys.houseMeterTariffs(), getHouseMeterTariffs, {
    placeholderData: [],
    staleTime: Infinity,
    ...options,
  });
